import DashboardWebmasterContent from "page_components/webmaster/dashboard/Content";
import DashboardProvider from "context/webmaster/dashboard";
import TasksProvider from "context/webmaster/tasks";

const Dashboard = () => {
  return (
    <DashboardProvider>
      <TasksProvider>
        <DashboardWebmasterContent />
      </TasksProvider>
    </DashboardProvider>
  );
};

export default Dashboard;
